<template>
    <v-card class="pa-5 elevation-0" flat>
      <h1 class="fonte text-uppercase">Importar Contatos</h1>
      <v-progress-linear v-if="enviando" :indeterminate="true"></v-progress-linear>
      <h1 v-if="enviando">Aguarde, enviando arquivo...</h1>
      <div v-if="!enviando"  class="mt-4">
        <v-alert :value="titulos.length == 0" color="teal" outline="" type="info" style="width: 450px; margin: 0;">
          Clique no botão abaixo para importar um arquivo .csv
        </v-alert>

        <!--<span v-if="sizeFile">
            <v-icon>attachment</v-icon>
            {{sizeFile}}
        </span>-->
        <span  v-if="qtdLinhas">
            <v-icon>short_text</v-icon>
            Quantidade de registros:
            <span>{{qtdLinhas}}</span>

        </span>
        <span  v-if="this.arquivo && this.arquivo.size > 1 && sizeFile">
            <v-icon>today</v-icon>
            Última modificacão em: {{datefile}}
        </span>
          <div>
            <!--<v-btn style="display:block;" @click="dialog=true" v-if="sizeFile" dark="" color="blue-grey">Adicionar Telefone</v-btn>-->
          </div>
          <input id="import" type="file" @change="processFile($event)" v-show="false" accept=".csv"/>
          <v-btn class="white--text" id="btnimport" @click.native="actionImport" color="fundo" v-if="titulos.length == 0">Escolher arquivo CSV  &nbsp;<v-icon dark="">backup</v-icon></v-btn>
          <div v-if="titulos.length &gt; 0" style="margin-top:30px;">
            <v-layout align-center="" justify-center="" row="" fill-height="">
              <v-select
                box="box"
                :items="titulos"
                v-model="templateCampanha.campoTelefone"
                label="Indique a coluna onde encontram-se os telefones"
              ></v-select>
            </v-layout>
            <v-layout justify-space-between="justify-space-between" row="row" wrap="wrap" >
              <v-flex>
                <v-text-field
                  color="blue-grey"
                  box="box"
                  label="Insira o nome do mailing"
                  required="required"
                  v-model="templateCampanha.nome"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!--
            <v-checkbox label="Tentar Push?" v-model="isPush" color="blue-grey"></v-checkbox>
            <v-checkbox label="Capturar Token?" v-model="captura" color="blue-grey"></v-checkbox>
            -->
            <!--<v-layout>
              <p>{{ getSmsCompiled() }}</p>
            </v-layout>-->
            <v-btn block="" color="fundo" dark="" @click="sendCadastroTemplateCampanha">Importar</v-btn>
          </div>
        </div>
        <!--<div v-if="!titulos.length > 0">
            <v-card>
              <v-list two-line class="mt-5" >
                <v-subheader class="teal--text">
                  <h2>Histórico de importações</h2>
                </v-subheader>
                <v-divider></v-divider>

                <div class="boxgray">
                  <v-list-tile >
                    <v-list-tile-avatar>
                      <v-icon large>insert_drive_file</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title v-html="`<span>Título</span>`"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="`<i>Formato</i> - <i>${new Date().toLocaleString()}</i>`"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card>
        </div>-->

        <v-data-table
          :headers="headers"
          :items="getTemplatesCampanha"
          hide-actions="hide-actions"
          :loading="isLoadingTemplates"
          disable-initial-sort
          no-data-text="Nenhum dado encontrado"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.nome }}</td>
            <td class="text-xs-center">{{ convertDataBr(props.item.createdAt) }}</td>
            <td class="text-xs-center">{{ props.item.qtdLinhas || '' }}</td>
            <td class="text-xs-center">
              <v-switch
                v-model="props.item.ativo"
                @change="updateStatusMailing($event, props.item)"
              ></v-switch>
            </td>
          </template>
        </v-data-table>

        <v-dialog v-model="loading" hide-overlay="" persistent="" width="300">
          <v-card class="white--text" color="blue-grey" dark="">
            <v-card-text>
              Por favor, Aguarde!
              <v-progress-linear class="mb-0" indeterminate="" color="white"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
  </template>


<script>
import Papa from 'papaparse'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import makeSlug from './../../helpers/makeSlug'
import * as helpers from './../../helpers/helpers'
export default {
  data () {
    return {
      enviando: false,
      loading: false,
      dialog: false,
      tempDdd: '',
      tempFone: '',
      grupos: [
        { campo: "nome", is: ["nom"], not: [], selected: '' }
      ],
      rulesMessage: [v => v.length <= 160 || 'Limite de caracteres'],
      isPush: false,
      captura: false,
      campoTelefone: null,
      telefones: [],
      titulos: [],
      qtdLinhas: null,
      sizeFile: '',
      nameFile: '',
      datefile: '',
      arquivo: null,
      templateCampanha: {
        campoTelefone: '',
        nome: ''
      },
      templates: [],
      isLoadingTemplates: false,
      headers: [
        { text: 'Nome', value: 'nome', align:'center', sortable: true, },
        { text: 'Data de criação', value: 'createdAt', align:'center', sortable: true },
        { text: 'Quantidade de linhas', value: 'qtdLinhas', align:'center', sortable: true },
        { text: 'Status', value: 'nome', align:'center', sortable: false, },

      ],
    }
  },
  methods: {
    ...mapActions(['arquivos_updateStatusArquivo', 'arquivos_saveArquivo', 'arquivos_saveArquivoTemplateCampanha', 'arquivos_getArquivoTemplateCampanha', 'arquivos_sendCampanha']),
    
    async updateStatusMailing(event, mailing) {
      let m = { _id: mailing._id, ativo: event }
      await this.arquivos_updateStatusArquivo(m)
    },

    convertDataBr (data) {
      return helpers.getDateTimeZoneBR(data)
    },
    addFone()
    {
      if( !this.tempFone ) return alert("Falta telefone!")
      this.telefones.push( {ddd:this.tempDdd, numero: this.tempFone} )
      this.tempDdd=''
      this.tempFone=''
    },
    reset()
    {

      this.titulos = []
      this.telefones=[]
    },
    actionImport()
    {
      document.querySelector("#import").click()
    },
    getSmsCompiled () {
      let variaveis = [{label:'${nome}', alt:'NOME DA PESSOA'}, {label:'${idade}', alt:'IDADE DA PESSOA'}]
      return this.mensagem.split(' ').map( p => {
        let tem = variaveis.find( v => p.includes(v.label) )
        return tem ? p.replace(tem.label, tem.alt)  : p
      }).join(" ")
    },
    processFile(event) {
      moment.locale('pt-br')
      this.loading = true
      this.reset()

      this.arquivo = event.target.files[0]
      this.nameFile= this.arquivo.name
      this.sizeFile= this.arquivo.size > 1 ? ((this.arquivo.size / 1024) / 1024).toString().substr(0,7) + " MB" : 'Tamanho do arquivo menor ou igual a 1 byte'
      this.datefile= moment( this.arquivo.lastModified ).format('LL')

      Papa.parse(this.arquivo, {
        complete: results => {
          if(results.data[0] != "" && results.data[1] != "")
          {
              if(results.data[results.data.length] != "") this.qtdLinhas = results.data.length - 2
              this.titulos   = results.data[0]

                if(  results.errors.length > 0 && results.data[0].length == 1)
                {
                    let delimiter
                    let t = this.titulos.join('@*@')

                    let virgula       = t.match(",") && t.match(",").index >= 0
                    let ponto_virgula = t.match(";") && t.match(";").index >= 0

                    if( !virgula && virgula !== 0 )
                        delimiter = ';'
                    else if( !ponto_virgula && ponto_virgula !== 0 )
                        delimiter = ','
                    else if( ponto_virgula > virgula )
                        delimiter = ';'
                    else delimiter = ','

                    this.titulos = this.titulos[0].split(delimiter)
                }

              this.titulos.push('')
              this.loading=false
          }
          else {
              this.$eventHub.emit('snackBar', {message:'Arquivo vazio'})
              this.loading=false
              this.reset()
          }
        }
      })
    },
    getTitles()
    {
      return this.titulos
    },
    async sendCadastroTemplateCampanha () {
      let formData = new FormData()
      if(this.templateCampanha.campoTelefone && this.arquivo && this.templateCampanha.nome) {
        formData.append("mailing", this.arquivo)
        formData.append("nome", this.templateCampanha.nome)
        formData.append("campoTelefone", this.titulos.indexOf(this.templateCampanha.campoTelefone))
        formData.append("qtdLinhas", this.qtdLinhas)
        this.enviando=true
        let r = await this.arquivos_saveArquivoTemplateCampanha(formData)
        if( r.status ) {
          this.$eventHub.emit('snackBar', {message: "Template cadastrado com sucesso"})

          Object.assign( this.$data, this.$options.data.apply(this) )
        }
        else this.$eventHub.emit('snackBar', {message: "Erro ao enviar"})
        this.titulos = []
        this.enviando=false
        this.arquivos_getArquivoTemplateCampanha()
        this.reset()
      }else{
        this.$eventHub.emit('snackBar', {message:'Preencha todos os campos'})
      }
    },
    async send () {
      let formData = new FormData()
      if (this.mensagem && this.arquivo && this.campoTelefone) {
        formData.append("mailing", this.arquivo)
        formData.append("mensagem", this.mensagem)
        formData.append("isPush", this.isPush)
        formData.append("captura", this.captura)
        formData.append("campoTelefone", this.titulos.indexOf(this.campoTelefone))
        this.enviando=true
        let r = await this.arquivos_saveArquivo(formData)
        if ( r.status ) {
          this.$eventHub.emit('snackBar', {message: "Servidor processando o arquivo"})
          Object.assign( this.$data, this.$options.data.apply(this) )
        }
        else this.$eventHub.emit('snackBar', {message: "Erro ao enviar"})
        this.titulos = []
        this.enviando = false
        this.reset()
      } else {
        this.$eventHub.emit('snackBar', { message: 'Preencha todos os campos' })
      }
    },
    getIndex( col ) {
      if(!col)return -1
      return this.titulos.findIndex( (item, index) => item.toLowerCase() === col.toLowerCase() )
    },

    getSlug (text) {
      return makeSlug(text)
    }
  },
  mounted () {
      this.arquivos_getArquivoTemplateCampanha()
  },
  computed:{
    ...mapGetters(['getTemplatesCampanha']),
    getTitlesFone()
    {
      //retornar colunas que: não foram selecionadas no form e não estão em telefones
      return this.titulos.filter( t => {
        return  this.grupos.filter( g => g.selected.toLowerCase() == t.toLowerCase() ).length == 0
                && this.telefones.filter( f => f.numero.toLowerCase() == t.toLowerCase() || f.ddd.toLowerCase() == t.toLowerCase() ).length == 0
                || t == ''
      })
    },
    getTitlesDdd()
    {
      //retornar colunas que: não foram selecionadas no form e não estão em telefones
      return this.titulos.filter( t => {
        return  this.grupos.filter( g => g.selected.toLowerCase() == t.toLowerCase() ).length == 0
                && this.telefones.filter( f => f.numero.toLowerCase() == t.toLowerCase() || f.ddd.toLowerCase() == t.toLowerCase() ).length == 0
                || t == ''
      })
    }
  },
  watch: {
    'campanha.mensagem' () {
			this.campanha.mensagem = this.getSlug(this.campanha.mensagem)
		}
  }
}
</script>

<style scoped lang="stylus">

  #btnimport
    display block
    margin-top 30px

  .boxgray
    border-bottom 1px solid #ededed
    height 400px
    overflow-y auto

</style>






// WEBPACK FOOTER //
// src/components/user/Mailing.vue